import React, { type ReactNode } from 'react';

import type { IconProps } from '#@/components/Icon';

import { Callout } from './Callout';
import type { INFO_MESSAGE_TYPE } from './types';

interface InfoMessageProps {
  type: INFO_MESSAGE_TYPE;
  children: ReactNode | ReactNode[];
  marginBottom?: boolean | number;
  suffix?: React.ReactNode;
  icon?: IconProps['type'];
  withoutIcon?: boolean;
}

/**
 * @deprecated Use `Callout` instead.
 */
export const InfoMessage: React.FC<InfoMessageProps> = ({
  type,
  children,
  marginBottom,
  suffix,
  icon,
  withoutIcon,
  ...props
}) => (
  <Callout
    variant={type}
    icon={withoutIcon ? null : icon}
    suffix={suffix}
    marginBottom={marginBottom}
    {...props}
  >
    {children}
  </Callout>
);
